/* eslint-disable import/no-cycle */
/* eslint-disable func-names */
import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import api from "../../../services/api";
import DateHelper from "../../../utils/dateHelper";
import {
	INITIAL_STATE_VALUES,
	Types
} from "../../ducks/alertas/dadoParametrizado";
import executeAction from "../comum/executeAction";

function convertDatasDadosParametrizados(dadoParametrizado) {
	const convertedDadoParametrizado = dadoParametrizado;

	if (dadoParametrizado.horaOcorrencia) {
		convertedDadoParametrizado.horaOcorrencia = DateHelper.convertStringDate(
			dadoParametrizado.horaOcorrencia,
			"HH:mm",
			"HH:mm:ss"
		);
	}

	if (dadoParametrizado.dataOcorrencia) {
		convertedDadoParametrizado.dataOcorrencia = DateHelper.convertStringDate(
			dadoParametrizado.dataOcorrencia,
			"DD/MM/YYYY",
			"YYYY-MM-DD"
		);
	}

	if (dadoParametrizado.dataInicial) {
		convertedDadoParametrizado.dataInicial = DateHelper.convertStringDate(
			dadoParametrizado.dataInicial,
			"DD/MM/YYYY",
			"YYYY-MM-DD"
		);
	}

	if (dadoParametrizado.dataFinal) {
		convertedDadoParametrizado.dataFinal = DateHelper.convertStringDate(
			dadoParametrizado.dataFinal,
			"DD/MM/YYYY",
			"YYYY-MM-DD"
		);
	}

	return convertedDadoParametrizado;
}

function* asyncDadoParametrizadoBuscarPorAlertaId(action) {
	yield executeAction(function* execute() {
		const { alertaId, callback } = action;

		const { data } = yield call(api.get, `/alerta/buscar/${alertaId}`);

		let { dadoParametrizado } = data;

		dadoParametrizado =
			dadoParametrizado || INITIAL_STATE_VALUES.dadoParametrizado;

		dadoParametrizado.alertaId = data.id;

		dadoParametrizado.alertaStatus = data.statusAtualAlerta;

		dadoParametrizado = convertDatasDadosParametrizados(dadoParametrizado);

		yield put({
			type: Types.DADO_PARAMETRIZADO_BUSCAR_POR_ALERTA_ID_REDUCER,
			dadoParametrizado,
			data
		});

		if (callback) callback(false);
	}, Types.DADO_PARAMETRIZADO_BUSCAR_POR_ALERTA_ID);
}

function* takeDadoParametrizadoBuscarPorAlertaId() {
	yield takeLatest(
		Types.DADO_PARAMETRIZADO_BUSCAR_POR_ALERTA_ID,
		asyncDadoParametrizadoBuscarPorAlertaId
	);
}

export default function* root() {
	yield all([fork(takeDadoParametrizadoBuscarPorAlertaId)]);
}
